<div *ngIf="item && item.cells" class="container " class="flex flex-row justify-between items-center">
  <div [ngClass]="fieldDefinition?.metaData?.HideEllipsis === 'true' ? '' : 'grid-cell-ellipsis'"
       matTooltip="{{item.cells[fieldDefinition.key] ? (item.cells[this.fieldDefinition.key].value?.toolTip ? item.cells[this.fieldDefinition.key].value?.toolTip : item.cells[fieldDefinition.key].displayText) : ''}}">
    {{item.cells[fieldDefinition.key] ? item.cells[fieldDefinition.key].displayText : ''}}
  </div>
  <button
    (click)="onClicked('Edit')"
    *ngIf="editField && !item.cells['IsDefault'].value && !fieldDefinition.isReadOnly && (!item.isReadOnly || fieldDefinition?.metaData?.CanCellUnlock === 'true')"
    class="icon-dropdown-button" matTooltip="Edit" mat-icon-button>
    <mat-icon>create</mat-icon>
  </button>
</div>
